const isSimOnlyPlan = plan =>
  plan?.groupName?.toUpperCase().includes('SIM ONLY');

export default isSimOnlyPlan;
